import { Controller } from "@hotwired/stimulus"

// Periodically reloads the turbo-frame it's attached to while a
// [data-poll-finished] marker inside reports "false", then stops.
//
// Fallback for websocket broadcasts that fire before the page's stream
// subscription is up — e.g. an agent install job failing fast, right
// between the redirect and the cable connect — which otherwise left the
// card stuck on its render-time state until a manual refresh.
export default class extends Controller {
  static values = { interval: { type: Number, default: 4000 } }

  connect() {
    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const marker = this.element.querySelector("[data-poll-finished]")
    if (marker && marker.dataset.pollFinished !== "false") {
      clearInterval(this.timer)
      return
    }

    if (this.element.src) {
      this.element.reload()
    } else {
      this.element.src = window.location.href
    }
  }
}
